export default function changePrepositionForm(preposition, city) {
    let result = preposition;

    if (preposition && preposition.toLowerCase() === 'в') {
        const PREPOSITION_FROM_CITY_EXCEPTIONS = [
            "Владивосток",
            "Владикавказ",
            "Владимир"
        ];
        const isCityException = () => {
            return PREPOSITION_FROM_CITY_EXCEPTIONS.some((currentCity) => {
                return city.toLowerCase() === currentCity.toLowerCase();
            });
        };
        if (isCityException()) result += 'о'
    }

    return result;
};